import { render } from "./option.vue?vue&type=template&id=15d521b8&scoped=true&ts=true"
import script from "./option.vue?vue&type=script&lang=ts"
export * from "./option.vue?vue&type=script&lang=ts"

import "./option.vue?vue&type=style&index=0&id=15d521b8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15d521b8"]])

export default __exports__